export enum GiftCardDuration {
  SixMonths = 'sixMonths',
  OneYear = 'oneYear',
  ForLife = 'lifeTime',
}